import { BaseFetch } from "../main-model";
export default class AwardModel extends BaseFetch {
  getAwardBy = (data) =>
    this.authFetch({
      url: "award/getAwardBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getAwardById = (data) =>
    this.authFetch({
      url: "award/getAwardById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateAwardById = (data) =>
    this.authFetch({
      url: "award/updateAwardById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertAward = (data) =>
    this.authFetch({
      url: "award/insertAward",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteAwardById = (data) =>
    this.authFetch({
      url: "award/deleteAwardById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertStudentInAwardSet = (data) =>
    this.authFetch({
      url: "award/insertStudentInAwardSet",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteStudentInAwardAllById = (data) =>
    this.authFetch({
      url: "award/deleteStudentInAwardAllById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateStudentInAwardById = (data) =>
    this.authFetch({
      url: "award/updateStudentInAwardById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
